import { useQuery } from '@tanstack/react-query';

import { getProjectEntitlements } from '@/features/subscriptions/api/get-project-entitlements';

export const PROJECT_ENTITLEMENTS_QUERY_KEY = 'project-entitlements';

export function useProjectEntitlements(projectId: number | undefined) {
  return useQuery({
    queryKey: [PROJECT_ENTITLEMENTS_QUERY_KEY, projectId],
    queryFn: () => getProjectEntitlements(projectId!),
    enabled: !!projectId,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}

export function useProjectUsagePermissions(projectId: number | undefined) {
  return (
    useProjectEntitlements(projectId)?.data?.usage_permissions ?? {
      can_add_seat: false,
      can_add_subproject: false,
      can_add_standard_kpi: false,
      can_add_derivative_kpi: false,
    }
  );
}
